import React from 'react';

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import 'CSS/demand-supply/demand-supply.scss';

class AddDialog extends React.Component {
  render() {
    return (
      <Dialog
        maxWidth={'xs'}
        open={this.props.isOpen}
        onClose={this.props.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>This search has one or more custom criteria</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            If you re-use this search, new criteria will be added to your
            criteria set. Are you sure you want to proceed?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.handleClose}>Cancel</Button>
          <Button
            onClick={this.props.doAdd}
            variant="contained"
            color="primary"
          >
            Re-use
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default AddDialog;
